// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"f1e3d119","513":"0010b966","807":"aa582361"}[chunkId] + ".chunk.css";
};